import React, { useContext, useEffect } from "react";
import InputCustom from "../../../../../../components/Input";
import { getIn } from "formik";
import VoucherCurrency from "./VoucherCurrency";
import { CampaignCreateEditContext } from "../../../../reducers/CampaignCreateEditContext";

const VoucherFixed = () => {
  const { errors, touched, isSubmitting, handleChange, values } = useContext(
    CampaignCreateEditContext
  );

  return (
    <div className={"campaign-create-type"}>
      <InputCustom
        label={"Voucher value"}
        labelRequired
        value={values.voucher_reward.value}
        name={"voucher_reward.value"}
        onChange={handleChange}
        error={getIn(errors, "voucher_reward.value")}
        touched={getIn(touched, "voucher_reward.value")}
        disabled={isSubmitting}
        removeLetter
      />
      <VoucherCurrency />
      <InputCustom
        label={"Voucher valid for X days from the date a user redeems it"}
        value={values.voucher_reward.redeem_duration}
        name={"voucher_reward.redeem_duration"}
        onChange={handleChange}
        error={getIn(errors, "voucher_reward.redeem_duration")}
        touched={getIn(touched, "voucher_reward.redeem_duration")}
        disabled={isSubmitting}
        labelRequired
        removeLetter
      />
    </div>
  );
};

export default VoucherFixed;
